import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import styles from './confirm-upsell-button.module.less';
import { messages } from './messages';
import { useGlobalModalLaunchContext } from '../../../contexts/modal-context/global-modal-context';
import { PageEvents, useTrackEvent } from '../../../pages/settings/payment-and-subscription/hooks/use-track-event';
import { EventSourceStrings, Workflows } from '../../../tracking/tracking-constants';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';

/**
 * @param {object} props
 * @param {() => void} props.onCloseModal
 * @param {boolean} [props.shouldTrackUpsell]
 * @returns {React.JSX.Element}
 */
export const ConfirmFeatureUpsellButton = ({ onCloseModal, shouldTrackUpsell = false }) => {
  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext();
  const trackSubscriptionChangeStart = useTrackEvent(PageEvents.SUBSCRIPTION_CHANGE_START, EventSourceStrings.UPSELL_MODAL);
  const trackUpsellWorkflow = useTrackWorkflow(Workflows.UPSELL_BILLING_PLAN_FLOW);

  const onClickConfirm = useCallback(() => {
    if (shouldTrackUpsell) {
      const { workflowGuid } = trackUpsellWorkflow(WorkflowSteps.COMPLETE);
      trackSubscriptionChangeStart({ upsellWorkflowGuid: workflowGuid });
      openManageSubscriptionDrawer({ upsellWorkflowGuid: workflowGuid });
    } else {
      trackSubscriptionChangeStart();
      openManageSubscriptionDrawer();
    }

    onCloseModal();
  }, [trackSubscriptionChangeStart, shouldTrackUpsell, onCloseModal, trackUpsellWorkflow, openManageSubscriptionDrawer]);

  return (
    <Button className={styles['activate-upsell-button']} onClick={onClickConfirm} theme='primary'>
      <FormattedMessage {...messages.upgradeOnPaymentsAndSubscriptions} />
    </Button>
  );
};
